module.exports = __webpack_public_path__ + "static/img/s-apple-2.9ff6bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-apple-2.png
// module id = QaLn
// module chunks = 1